<template>
  <div class="mask" @click="closeMak">
    <img src="../../../assets/arrow.png" alt="" />
    <div class="tip">
      请点击上方 <span style="font-weight: bold">. . .</span> 分享给朋友
    </div>
  </div>
</template>

<script>
export default {
  props: ["showMask"],
  data() {
    return {};
  },

  mounted() {},

  methods: {
    closeMak() {
      this.$emit("update:showMask", false);
    },
  },
};
</script>

<style lang="less" scoped>
.mask {
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  background: rgba(76, 76, 76, 0.7);
  z-index: 2;
  img {
    width: 150px;
    height: 150px;
    position: absolute;
    right: 50px;
  }
  .tip {
    position: absolute;
    right: 60px;
    top: 170px;
    color: white;
  }
}
</style>
